import { useEffect, useState } from 'react';
import {
    Button,
    Stack,
    styled,
    Grid,
    Typography,
    Box,
    List,
    ListItem,
    TextField,
    InputAdornment,
    IconButton,
    MenuItem
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import NoObjectMessage from 'views/common/NoObjectMessage';
import { useNavigate, useParams } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { AddCircleOutline } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import binIcon from 'assets/images/icons/Bin.svg';
import { ReactComponent as LessThen } from '../../../assets/images/icons/icon-less.svg';
import { ReactComponent as GreaterThen } from '../../../assets/images/icons/icon-greater.svg';
import { ReactComponent as LessThenEqualTo } from '../../../assets/images/icons/icon-less-equal.svg';
import { ReactComponent as GreaterThenEqualTo } from '../../../assets/images/icons/icon-greater-equal.svg';
import { AssignmentRules, Rules, RulesParameter, Ruleschapters, Rulesexams } from 'types/assignmentrules';
import { getAssignmentRule } from 'services/RulesService';
import { useDispatch, useSelector } from 'react-redux';
import { SET_RULES_DATA_CONDITION, SET_VALUE } from 'store/slices/rules';
import sx from '@mui/system/sx';
import { style } from '@mui/system';

// const initialParametersLegality: ParametersLegality = {
//     id: '',
//     name: '',
//     type_id: 1,
//     display_name: '',
//     objects: [],
//     file: {
//         file_path: '',
//         upload_data: null,
//         file_name: ''
//     }
// };

function ParametersLegality() {
    const [objects, setObjects] = useState<Rules[]>([]);
    const { id } = useParams();
    const intl = useIntl();
    const dispatch = useDispatch();

    const [assignmentRule, setAssignmentRule] = useState<AssignmentRules>();
    // const [assignmentRulesParameter, setAssignmentRulesParameter] = useState<RulesParameter[]>([]);
    // const [assignmentRulesChapters, setAssignmentRulesChapters] = useState<Ruleschapters[]>([]);
    // const [assignmentRulesExams, setAssignmentRulesExams] = useState<Rulesexams[]>([]);
    const [selectedOperator, setSelectedOperator] = useState('');

    const [parameterList, setparameterList] = useState<{
        parameter: any;
        sub_parameter_1: string;
        sub_parameter_2: string;
        value: string;
        condition: string;
    }>({ parameter: '', sub_parameter_1: '', sub_parameter_2: '', value: '', condition: '' });
    const rulesata = useSelector((state: any) => state.rules.rules);

    const submitHandler = async () => {};

    const handleAddObject = () => {
        // Create a new object and add it to the state
        const newObject = {
            id: 0,
            parameters: '',
            sub_parameter_1: '',
            sub_parameter_2: '',
            value: '',
            condition: '',
            unique_id: uuidv4(),
            equation_label: '' || null
        };

        const updatedObjects = [...objects, newObject];
        setObjects(updatedObjects);
    };
    const subject = ['אנגלית', 'מילולי', 'כמותי', 'כללי', 'מקצועי', 'למידה'];
    const ComparisonOperators = [
        { label: 'Less Than', value: '<', icon: <LessThen style={{ height: '12px', width: '9px' }} /> },
        { label: 'Greater Than', value: '>', icon: <GreaterThen style={{ height: '12px', width: '9px' }} /> },
        { label: 'Less Than or Equal To', value: '<=', icon: <LessThenEqualTo style={{ height: '12px', width: '9px' }} /> },
        { label: 'Greater Than or Equal To', value: '>=', icon: <GreaterThenEqualTo style={{ height: '12px', width: '9px' }} /> }
    ];

    const handleDeleteObject = (deletedItemId: string) => {
        const updatedObjects = objects.filter((item) => item.unique_id !== deletedItemId);
        setObjects(updatedObjects);
        dispatch({
            type: SET_VALUE,
            payload: updatedObjects
        });
    };
    useEffect(() => {
        getAssignmentRule(id, setAssignmentRule);
        // getAssignmentRulesParameter(setAssignmentRulesParameter);
        // getAssignmentRuleschapters(id, setAssignmentRulesChapters);
        // getAssignmentRulesexams(setAssignmentRulesExams);
    }, [id]);
    useEffect(() => {
        setObjects(rulesata);
    }, [rulesata]);
    // const getIconByValue = (value: any) => {
    //     return value == '<' ? <LessThen /> : <GreaterThen />;
    // };
    const iconMap: any = {
        '<': <LessThen />,
        '>': <GreaterThen />,
        '<=': <LessThenEqualTo />,
        '>=': <GreaterThenEqualTo />
    };

    const getIconByValue = (value: any) => iconMap[value] || null;

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <MainCard
                        title={
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: '#000000' }}>
                                    <FormattedMessage id="parameters-for-legality" />
                                </Typography>
                                <Typography
                                    sx={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#7A49B9', cursor: 'pointer' }}
                                    onClick={handleAddObject}
                                >
                                    <AddCircleOutline
                                        onClick={handleAddObject}
                                        fontSize="small"
                                        sx={{ position: 'relative', color: '#7A49B9', cursor: 'pointer' }}
                                    />
                                    <FormattedMessage id="adding-parameter" />
                                </Typography>
                            </Box>
                        }
                    >
                        {objects.length === 0 ? (
                            <NoObjectMessage informativeMessage="no-object-message" actionMessage="no-object-action-message" />
                        ) : (
                            <>
                                <Box sx={{ minHeight: 100 }}>
                                    {objects.map((item: any, index: any) => (
                                        <ListItem alignItems="center">
                                            <Stack direction="row" spacing={3} alignItems="center" width="100%">
                                                <Typography>{index + 1}</Typography>
                                                <TextField
                                                    select
                                                    label={intl.formatMessage({ id: 'parameter' })}
                                                    value={item.parameters}
                                                    variant="outlined"
                                                    sx={{ width: '214px' }}
                                                    onChange={(e) => {
                                                        const updatedItems = [...objects];

                                                        const itemIndex = updatedItems.findIndex((i) => i.unique_id == item.unique_id);

                                                        updatedItems[itemIndex].parameters = e.target.value;
                                                        if (updatedItems[itemIndex].parameters == 1) {
                                                            updatedItems[itemIndex].sub_parameter_1 = 'שעות';
                                                        } else if (updatedItems[itemIndex].parameters == 2) {
                                                            updatedItems[itemIndex].sub_parameter_1 = assignmentRule?.qustion_tags[0]?.name;
                                                        } else if (updatedItems[itemIndex].parameters == 3) {
                                                            updatedItems[itemIndex].sub_parameter_1 =
                                                                assignmentRule?.exams[0]?.preview_name;
                                                        } else {
                                                            updatedItems[itemIndex].sub_parameter_1 = '';
                                                        }
                                                        // updatedItems[itemIndex].parameters == 2 ?  : '') ||

                                                        const selectedName: any = assignmentRule?.parameters
                                                            .filter((o: any) => o.id === e.target.value)
                                                            .map((filteredObject: any) => filteredObject.name);

                                                        updatedItems[itemIndex].equation_label = `${
                                                            selectedName.length > 0 ? selectedName[0] : ''
                                                        } ${
                                                            updatedItems[itemIndex].sub_parameter_1 == null
                                                                ? ''
                                                                : updatedItems[itemIndex].sub_parameter_1
                                                        } ${
                                                            updatedItems[itemIndex].sub_parameter_2 == null
                                                                ? ''
                                                                : updatedItems[itemIndex].sub_parameter_2
                                                        } ${
                                                            updatedItems[itemIndex].condition == null
                                                                ? ''
                                                                : updatedItems[itemIndex].condition
                                                        } ${updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value}`;

                                                        setObjects(updatedItems);
                                                        dispatch({
                                                            type: SET_VALUE,
                                                            payload: updatedItems
                                                        });
                                                    }}
                                                >
                                                    {assignmentRule?.parameters?.map((data: any) => (
                                                        <MenuItem value={data?.id}>{data?.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                                <TextField
                                                    select
                                                    value={
                                                        item?.sub_parameter_1 ||
                                                        (item?.parameters == 1 ? 'שעות' : '') ||
                                                        (item?.parameters == 2 ? assignmentRule?.qustion_tags[0]?.name : '') ||
                                                        (item?.parameters == 3 ? assignmentRule?.exams[0]?.preview_name : '')
                                                    }
                                                    label={intl.formatMessage({ id: 'Selection-from-the-selected-parameter' })}
                                                    variant="outlined"
                                                    sx={{ width: '214px' }}
                                                    onChange={(e) => {
                                                        const updatedItems = [...objects];
                                                        const itemIndex = updatedItems.findIndex((i) => i.unique_id === item.unique_id);
                                                        updatedItems[itemIndex].sub_parameter_1 = e.target.value;

                                                        const selectedName: any = assignmentRule?.parameters
                                                            .filter((o: any) => o.id === updatedItems[itemIndex].parameters)
                                                            .map((filteredObject: any) => filteredObject.name);

                                                        const question_label: any = assignmentRule?.qustion_tags?.filter(
                                                            (data: any) => data?.id == e.target.value
                                                        );
                                                        let subParameter1Value;

                                                        if (item.parameters == 2) {
                                                            subParameter1Value = question_label[0].name;
                                                        } else {
                                                            subParameter1Value = updatedItems[itemIndex].sub_parameter_1;
                                                        }

                                                        updatedItems[itemIndex].equation_label = `${
                                                            selectedName.length > 0 ? selectedName[0] : ''
                                                        } ${subParameter1Value}  ${
                                                            updatedItems[itemIndex].sub_parameter_2 == null
                                                                ? ''
                                                                : updatedItems[itemIndex].sub_parameter_2
                                                        } ${
                                                            updatedItems[itemIndex].condition == null
                                                                ? ''
                                                                : updatedItems[itemIndex].condition
                                                        } ${updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value}`;

                                                        dispatch({
                                                            type: SET_VALUE,
                                                            payload: updatedItems
                                                        });
                                                        setObjects(updatedItems);
                                                    }}
                                                >
                                                    {item?.parameters == 1 && (
                                                        <MenuItem value="שעות" key={1}>
                                                            שעות
                                                        </MenuItem>
                                                    )}

                                                    {item?.parameters == 2 &&
                                                        assignmentRule?.qustion_tags.map((value: any, vi: number) => (
                                                            <MenuItem key={vi} value={value?.id}>
                                                                {value?.name}
                                                            </MenuItem>
                                                        ))}
                                                    {item?.parameters == 3 &&
                                                        assignmentRule?.exams.map((data: any, di: number) => (
                                                            <MenuItem value={data?.preview_name} key={di}>
                                                                {data?.preview_name}
                                                            </MenuItem>
                                                        ))}
                                                </TextField>
                                                <TextField
                                                    disabled={item?.parameters == 1 || item?.parameters == 2 || item?.parameters == ''}
                                                    select
                                                    label={intl.formatMessage({ id: 'Selection-from-the-selected-parameter' })}
                                                    value={item?.sub_parameter_2}
                                                    onChange={(e) => {
                                                        const updatedItems = [...objects];

                                                        const itemIndex = updatedItems.findIndex((i) => i.unique_id == item.unique_id);

                                                        updatedItems[itemIndex].sub_parameter_2 = e.target.value;

                                                        const selectedName: any = assignmentRule?.parameters
                                                            .filter((o: any) => o.id === updatedItems[itemIndex].parameters)
                                                            .map((filteredObject: any) => filteredObject.name);

                                                        const question_label: any = assignmentRule?.qustion_tags?.filter(
                                                            (data: any) => data?.id == updatedItems[itemIndex].sub_parameter_1
                                                        );
                                                        let subParameter1Value;

                                                        if (item.parameters == 2) {
                                                            subParameter1Value = question_label[0].name;
                                                        } else {
                                                            subParameter1Value = updatedItems[itemIndex].sub_parameter_1;
                                                        }

                                                        updatedItems[itemIndex].equation_label = `${
                                                            selectedName.length > 0 ? selectedName[0] : ''
                                                        } ${updatedItems[itemIndex].sub_parameter_1 == null ? '' : subParameter1Value} ${
                                                            updatedItems[itemIndex].sub_parameter_2 == null
                                                                ? ''
                                                                : updatedItems[itemIndex].sub_parameter_2
                                                        } ${
                                                            updatedItems[itemIndex].condition == null
                                                                ? ''
                                                                : updatedItems[itemIndex].condition
                                                        } ${updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value}`;
                                                        dispatch({
                                                            type: SET_VALUE,
                                                            payload: updatedItems
                                                        });
                                                        setObjects(updatedItems);
                                                    }}
                                                    variant="outlined"
                                                    sx={{ width: '230px' }}
                                                >
                                                    {subject?.map((data: any) => (
                                                        <MenuItem value={data}>{data}</MenuItem>
                                                    ))}
                                                </TextField>
                                                <TextField
                                                    select
                                                    variant="outlined"
                                                    size="medium"
                                                    sx={{ width: '60px' }}
                                                    value={item?.condition}
                                                    inputProps={
                                                        {
                                                            // sx: { padding: '10px' }
                                                        }
                                                    }
                                                    onChange={(e) => {
                                                        const updatedItems = [...objects];

                                                        const itemIndex = updatedItems.findIndex((i) => i.unique_id == item.unique_id);

                                                        updatedItems[itemIndex].condition = e.target.value;

                                                        const selectedName: any = assignmentRule?.parameters
                                                            .filter((o: any) => o.id === updatedItems[itemIndex].parameters)
                                                            .map((filteredObject: any) => filteredObject.name);
                                                        const question_label: any = assignmentRule?.qustion_tags?.filter(
                                                            (data: any) => data?.id == updatedItems[itemIndex].sub_parameter_1
                                                        );
                                                        let subParameter1Value;

                                                        if (item.parameters == 2) {
                                                            subParameter1Value = question_label[0].name;
                                                        } else {
                                                            subParameter1Value = updatedItems[itemIndex].sub_parameter_1;
                                                        }
                                                        updatedItems[itemIndex].equation_label = `${
                                                            selectedName.length > 0 ? selectedName[0] : ''
                                                        } ${updatedItems[itemIndex].sub_parameter_1 == null ? '' : subParameter1Value} ${
                                                            updatedItems[itemIndex].sub_parameter_2 == null
                                                                ? ''
                                                                : updatedItems[itemIndex].sub_parameter_2
                                                        } ${
                                                            updatedItems[itemIndex].condition == null
                                                                ? ''
                                                                : updatedItems[itemIndex].condition
                                                        } ${updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value}`;
                                                        updatedItems[itemIndex].unique_id = uuidv4();
                                                        dispatch({
                                                            type: SET_VALUE,
                                                            payload: updatedItems
                                                        });
                                                        setObjects(updatedItems);
                                                    }}
                                                >
                                                    {ComparisonOperators.map((operator: any, idx: number) => (
                                                        <MenuItem key={idx} value={operator?.value}>
                                                            {operator.icon}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>

                                                {item?.parameters == 3 ? (
                                                    <TextField
                                                        value={item?.value}
                                                        label={intl.formatMessage({ id: 'enter-value' })}
                                                        variant="outlined"
                                                        sx={{ width: '138px' }}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const updatedItems = [...objects];

                                                            const itemIndex = updatedItems.findIndex((i) => i.unique_id == item.unique_id);

                                                            updatedItems[itemIndex].value = e.target.value;
                                                            const selectedName: any = assignmentRule?.parameters
                                                                .filter((o: any) => o.id === updatedItems[itemIndex].parameters)
                                                                .map((filteredObject: any) => filteredObject.name);
                                                            const question_label: any = assignmentRule?.qustion_tags?.filter(
                                                                (data: any) => data?.id == updatedItems[itemIndex].sub_parameter_1
                                                            );
                                                            let subParameter1Value;

                                                            if (item.parameters == 2) {
                                                                subParameter1Value = question_label[0].name;
                                                            } else {
                                                                subParameter1Value = updatedItems[itemIndex].sub_parameter_1;
                                                            }

                                                            updatedItems[itemIndex].equation_label = `${
                                                                selectedName.length > 0 ? selectedName[0] : ''
                                                            } ${
                                                                updatedItems[itemIndex].sub_parameter_1 == null ? '' : subParameter1Value
                                                            } ${
                                                                updatedItems[itemIndex].sub_parameter_2 == null
                                                                    ? ''
                                                                    : updatedItems[itemIndex].sub_parameter_2
                                                            } ${
                                                                updatedItems[itemIndex].condition == null
                                                                    ? ''
                                                                    : updatedItems[itemIndex].condition
                                                            } ${
                                                                updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value
                                                            }`;
                                                            dispatch({
                                                                type: SET_VALUE,
                                                                payload: updatedItems
                                                            });
                                                            setObjects(updatedItems);
                                                        }}
                                                    />
                                                ) : (
                                                    <TextField
                                                        value={item?.value}
                                                        variant="outlined"
                                                        label={intl.formatMessage({ id: 'enter-value' })}
                                                        sx={{ width: '138px' }}
                                                        type="number"
                                                        onChange={(e) => {
                                                            const updatedItems = [...objects];

                                                            const itemIndex = updatedItems.findIndex((i) => i.unique_id == item.unique_id);

                                                            updatedItems[itemIndex].value = e.target.value;

                                                            const selectedName: any = assignmentRule?.parameters
                                                                .filter((o: any) => o.id == updatedItems[itemIndex].parameters)
                                                                .map((filteredObject: any) => filteredObject.name);
                                                            const question_label: any = assignmentRule?.qustion_tags?.filter(
                                                                (data: any) => data?.id == updatedItems[itemIndex].sub_parameter_1
                                                            );
                                                            let subParameter1Value;

                                                            if (item.parameters == 2) {
                                                                subParameter1Value = question_label[0].name;
                                                            } else {
                                                                subParameter1Value = updatedItems[itemIndex].sub_parameter_1;
                                                            }
                                                            updatedItems[itemIndex].equation_label = `${
                                                                selectedName.length > 0 ? selectedName[0] : ''
                                                            } ${
                                                                updatedItems[itemIndex].sub_parameter_1 == null ? '' : subParameter1Value
                                                            } ${
                                                                updatedItems[itemIndex].sub_parameter_2 == null
                                                                    ? ''
                                                                    : updatedItems[itemIndex].sub_parameter_2
                                                            } ${
                                                                updatedItems[itemIndex].condition == null
                                                                    ? ''
                                                                    : updatedItems[itemIndex].condition
                                                            } ${
                                                                updatedItems[itemIndex].value == null ? '' : updatedItems[itemIndex].value
                                                            }`;
                                                            dispatch({
                                                                type: SET_VALUE,
                                                                payload: updatedItems
                                                            });
                                                            setObjects(updatedItems);
                                                        }}
                                                    />
                                                )}
                                                <Box>
                                                    <IconButton
                                                        aria-label="clear"
                                                        color="inherit"
                                                        onClick={() => handleDeleteObject(item?.unique_id)}
                                                    >
                                                        <img src={binIcon} alt="delete icon" style={{ height: '18px', width: '20px' }} />
                                                    </IconButton>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                    ))}
                                </Box>
                            </>
                        )}
                    </MainCard>
                </Grid>
            </Grid>
        </>
    );
}

export default ParametersLegality;
function SetValueAction(arg0: { type: string; payload: Rules[] }): any {
    throw new Error('Function not implemented.');
}
